import { InitAdminService } from '@app/admin/services/init-admin.service';
import { MessageService } from '@app/shared/services/message.service';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { UserAuditService } from '@app/audit/services';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from '@app/auth/services';
import { UserAuditFilter } from '@app/audit/model';
import { first } from 'rxjs/operators';
import { ModuleTypeCss, ModuleTypeLabel } from '@app/shared/enum';

@Component({
  selector: 'content-audit-list',
  templateUrl: './user-audit-list.component.html',
  styleUrls: ['./user-audit-list.component.css'],
  providers: [DatePipe],
})
export class UserAuditListComponent implements OnInit {
  public list: any = [];
  public showTable: boolean;
  public dateNow = new Date();
  dataResult: boolean = false;
  public returnMessage = 'Selecione as opções do filtro para listar os dados.';

  public userDataList: Array<any>;
  public flagUserSelected: boolean = false;
  public flagSearchUser = false;
  public userList: any = [];
  public userId: any;
  public userData: any;

  public startDate: any;
  public endDate: any;

  public flagFiltering: boolean = false;

  public userAuditFilter: UserAuditFilter;

  public columns: Array<any> = [
    { title: 'Código', name: 'id', sort: 'asc', className: 'text-center' },
    { title: 'Usuário', name: 'user.name', sort: 'asc' },
    {
      title: 'Módulo',
      name: 'designModule',
      sort: 'asc',
      className: 'text-center fw-700',
      isHtmlData: true,
    },
    {
      title: 'Evento',
      name: 'designAuditEvent',
      sort: 'asc',
      className: 'text-center fw-700',
      isHtmlData: true,
    },
    {
      title: 'Endereço IP',
      name: 'ipAddress',
      sort: 'asc',
      className: 'text-center',
    },
    {
      title: 'Data de Ocorrência',
      name: 'timestamp',
      sort: 'asc',
      className: 'text-center text-primary datetime',
    },
  ];

  constructor(
    private initAdmin: InitAdminService,
    private userAuditService: UserAuditService,
    private loading: MessageService,
    private userService: UserService
  ) {
    this.userAuditFilter = new UserAuditFilter();
  }

  ngOnInit(): void {
    this.initAdmin.setConfigPage();
    this.dataResult = false;
    this.onLoadUsers();
  }

  onLoadUsers() {
    this.userService.getall().subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.userList = response.data;
          this.userDataList = this.getTemplateUser(response.data);
          this.userId = 0;
        } else {
          this.userList = new Array<any>();
          this.userDataList = new Array<any>();
        }
        this.flagSearchUser = false;
      },
      (error: any) => {
        this.flagSearchUser = false;
      }
    );
  }

  getTemplateUser(data: Array<any>): any[] {
    if (data != null && data.length > 0) {
      let arrayUsers: Array<any> = new Array<any>();
      this.userList = data.sort(function (a: any, b: any) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      for (let i = 0; i < data.length; i++) {
        const element: any = {
          id: data[i].id,
          name:
            this.pad(data[i].id, 6) +
            ' | ' +
            data[i].name +
            ' | ' +
            data[i].email,
        };
        arrayUsers.push(element);
      }
      return arrayUsers;
    }
    return new Array<any>();
  }

  pad(num: any, size: any) {
    if (num > 0) {
      num = num.toString();
      while (num.length < size) num = '0' + num;
      return num;
    }
    return num;
  }

  setUser(item: any) {
    if (item) {
      this.userId = item.id;
      this.userData = this.userList.find(
        (x: { id: number }) => x.id == item.id
      );
    }
  }

  setStartDate(event: any) {
    var value = event.target.value;
    if (value) {
      var year = value.split('-')[0];
      var month = value.split('-')[1];
      var day = value.split('-')[2];
      this.startDate = new Date(year, month - 1, day, 0, 0, 0, 0);
    }
  }

  setEndDate(event: any) {
    var value = event.target.value;
    if (value) {
      var year = value.split('-')[0];
      var month = value.split('-')[1];
      var day = value.split('-')[2];
      this.endDate = new Date(year, month - 1, day, 0, 0, 0, 0);
    }
  }

  designData(data: any[]) {
    data.forEach(function (e) {
      // if (e.auditEvent) {
      //   let auditEventCss = AuditEventTypeCss.get(e.auditEvent);
      //   let auditEventStr = AuditEventTypeLabel.get(e.auditEvent);
      //   e.designAuditEvent =
      //     "<span class='badge badge-pill w-100 " +
      //     auditEventCss +
      //     "'>" +
      //     auditEventStr +
      //     '</span>';
      // } else {
      //   e.designAuditEvent =
      //     "<span class='badge badge-pill w-100 badge-secondary'>Evento não encontrado</span>";
      // }

      if (e.userId >= 0 && e.user?.module?.moduleType >= 0) {
        let moduleTypeCss = ModuleTypeCss.get(e.user.module.moduleType);
        let moduleTypeStr = ModuleTypeLabel.get(e.user.module.moduleType);
        e.designModule =
          "<span class='badge badge-pill w-100 " +
          moduleTypeCss +
          "'>" +
          moduleTypeStr +
          '</span>';
      } else {
        e.designModule =
          "<span class='badge badge-pill w-100 badge-secondary'>Módulo não encontrado</span>";
      }
    });
    this.list = data;
  }

  getUserAudit(filter: any) {
    this.showTable = false;
    if (this.userId > 0) {
      this.flagFiltering = true;
      this.setFilterModel();
      this.userAuditService
        .getByFilter(this.userAuditFilter)
        .pipe(first())
        .subscribe(
          (response: any) => {
            if (response.typeResponse == TypeResponse.Success) {
              this.showTable = true;
              this.returnMessage = '';
              this.designData(response.data);
            } else {
              this.returnMessage = response.message;
              this.showTable = false;
            }
            this.flagFiltering = false;
          },
          (error: any) => {
            this.showTable = false;
            this.flagFiltering = false;
            this.returnMessage = 'Erro ao carregar os dados de auditoria.';
          }
        );
    } else {
      this.flagFiltering = false;
      this.showTable = false;
      this.returnMessage =
        'Selecione as opções do filtro para listar os dados.';
    }
  }

  private setFilterModel() {
    if (this.userId) {
      this.userAuditFilter.userId = this.userId;
    }
    if (this.startDate) {
      this.userAuditFilter.startDate = this.startDate;
    }
    if (this.endDate) {
      this.userAuditFilter.endDate = this.endDate;
    }
  }
}
